import { Formik, Form } from "formik";
import React, { useEffect } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import * as Yup from "yup";
import { GeneralTextAreaField } from "../Custom-Forms/General-Text-Area-Field";
import { axiosInstance } from "../../utils/axios-instance";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { RequestSignupSubmission } from "./Request-sign-up-verification-submission";
import { FormikOnError } from "../Custom-Forms/Formik-On-Error";

import { selectSignIn } from "../../store/slices/signed-in-slice";

export const RequestSignupVerification = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isSignedIn = useSelector(selectSignIn);
    const [searchParams] = useSearchParams();

    // Get email from param
    const autofillEmail = searchParams.get("email");

    // Make sure an email is provided before
    const resetPasswordValidationSchema = Yup.object({
        email: Yup.string().email("Invalid Email address").required("Applicant's email is required")
    });

    // If user is signed in,
    // redirect to the home page
    useEffect(() => {
        if (isSignedIn) {
            navigate("/");
        }
    }, [dispatch, isSignedIn, navigate]);
    return (
        <>
            <>
                <Container className="bg-body-secondary rounded-3 justify-content-center my-4 py-4">
                    <h1>Resend Email Verification</h1>
                    <Row className="card-background card-font">
                        <Formik
                            initialValues={{
                                email: autofillEmail ? autofillEmail : ""
                            }}
                            validationSchema={resetPasswordValidationSchema}
                            onSubmit={async (values, { setStatus }) => {
                                try {
                                    const response = await axiosInstance({
                                        method: "post",
                                        url: "/request-verify-account",
                                        headers: {
                                            "Content-Type": "application/json"
                                        },
                                        data: {
                                            email: values.email
                                        }
                                    });
                                    setStatus({ error: false });
                                } catch (error) {
                                    setStatus({ error: false });
                                    return Promise.reject(error);
                                }
                            }}
                        >
                            <Form>
                                <FormikOnError>
                                    <Row className="mx-0 mb-2">
                                        <h5>Enter email to resend your verification link. You will not be able to sign in until your email is verified.</h5>
                                        <GeneralTextAreaField
                                            autoFocus
                                            label="Email Address:"
                                            className="form-control"
                                            // component="textarea"
                                            component="input"
                                            name="email"
                                            rows="1"
                                            placeholder="Enter Email Address"
                                            autoComplete="email"
                                            aria-required="true"
                                            aria-label="Email Address Field"
                                        />
                                    </Row>
                                    <RequestSignupSubmission />
                                </FormikOnError>
                            </Form>
                        </Formik>
                    </Row>
                </Container>
            </>
        </>
    );
};
